<template>
  <div class="row">        
    <div style="float: none; margin: 0 auto; margin-bottom:1em">
      
      <div v-if="UsernameAdded">
        <p class="lead">Welcome to dacade {{UsernameAdded}}</p>
        <button style="margin-bottom: 1em;" class="btn btn-lg btn-secondary" @click="goToCourseSelection">Continue</button>

      </div>
      <div v-else>
        <div>
          <p class="lead">Please choose a username:</p>
        </div>
        <form>
            <div class="form-group" style="margin-bottom:1em">
              <label>username</label>
              <input type="username" class="form-control" id="username" placerholder="Enter username">
            </div>
            <button type="button" class="btn btn-primary btn-lg" style="" @click.prevent="registerUsername">Save</button>
        </form>
      </div>

      
    </div>      
  </div>
</template>

<script>
import Firebase from 'firebase'
import { store } from '../store/store.js'
import { dbUserCollectionRef } from '../firebaseConfig'


Firebase.auth().onAuthStateChanged(function(user) {
  if(user) {
    store.dispatch('setUser', user)
  } else {
    store.dispatch('setUser', null)
  }
});

export default {
  data() {
      return {
        UsernameAdded:''
      }
  },
  computed: {
    currentUser(){
      return this.$store.getters.currentUser
    },
    userCollection(){
      var data = this.$store.getters.getUserCollection
      return data
    },
    getReviews(){
      return this.$store.getters.getReviews
    },
    checkUsername(username){
      var userCollection = this.$store.getters.getUserCollection
      if (userCollection && username){
          var getUsername = userCollection.filter( data => {
              return  (data.displayName == username);
          });
          // console.log(new Date(chapterSubmission[0].date).toDateString());
          console.log(getUsername)
          return getUsername;
      }
    }
  },
  methods: {
    goToCourseSelection() {
        this.$router.push({name: 'CourseSelectionLink'})
    },
    registerUsername() {
      var username = document.getElementById('username').value;
      //console.log(this.currentUser.uid)
      var userId = this.currentUser.uid;
      //console.log(this.userCollection)

      //check if username already in db
      if (this.userCollection && username){
          var getUsername = this.userCollection.filter( data => {
              return  (data.displayName == username);
          });
          // console.log(new Date(chapterSubmission[0].date).toDateString());
          if (getUsername[0]){
            console.log(getUsername+" is duplicate")
            alert("Username: "+username+" alredy exists please choose another name")
          }
          else{
            //console.log(username+" is unique can be saved")
            var dataToPush = {uid:userId,displayName:username,learningPoints:0}
            dbUserCollectionRef.push(dataToPush)
            //update data in firebase user profile
            var user = Firebase.auth().currentUser;
            user.updateProfile({
                displayName: username
            })
            this.UsernameAdded = username
          }
      }
    }
  },
  created() {
    this.$store.dispatch('setUserCollectionRef', dbUserCollectionRef)
  }
}

</script>


// WEBPACK FOOTER //
// src/components/RegisterUsername.vue